document.addEventListener('DOMContentLoaded', function () {
	const ctaGridBoxes = document.querySelectorAll('.block-cta-grid__box');

	ctaGridBoxes.forEach((box) => {
		// Add class to indicate JS is active
		box.classList.add('has-interactive-gradient');

		// Create a gradient element that we can directly manipulate
		const gradientEl = document.createElement('div');
		gradientEl.className = 'block-cta-grid__gradient';
		gradientEl.style.cssText = `
			position: absolute;
			top: auto;
			left: 50%;
			width: 100%;
			height: 100%;
			background: radial-gradient(50% 50% at 50% 50%, rgba(255, 83, 30, 0.3) 0%, rgba(255, 83, 30, 0) 100%);
			transform: translate(-50%, -50%);
			pointer-events: none;
			bottom: -100%;
			z-index: 0;
		`;
		box.insertBefore(gradientEl, box.firstChild);

		let currentX = 0;
		let currentY = 0;
		let targetX = 0;
		let targetY = 0;
		let animationFrame = null;

		const updateGradient = () => {
			// Smooth interpolation
			currentX += (targetX - currentX) * 0.1;
			currentY += (targetY - currentY) * 0.1;

			// Apply transform directly to the element
			gradientEl.style.transform = `translate(calc(-50% + ${currentX}px), calc(-50% + ${currentY}px))`;

			// Continue animation if not close enough to target
			if (
				Math.abs(targetX - currentX) > 0.5 ||
				Math.abs(targetY - currentY) > 0.5
			) {
				animationFrame = requestAnimationFrame(updateGradient);
			} else {
				animationFrame = null;
			}
		};

		// Mouse move handler
		const handleMouseMove = (e) => {
			const rect = box.getBoundingClientRect();
			const centerX = rect.width / 2;
			const centerY = rect.height / 2;
			const mouseX = e.clientX - rect.left;
			const mouseY = e.clientY - rect.top;

			// Calculate offset from center (increased range for more noticeable effect)
			targetX = ((mouseX - centerX) / rect.width) * 100; // Max 100px movement
			targetY = ((mouseY - centerY) / rect.height) * 100;

			// Start animation if not already running
			if (!animationFrame) {
				animationFrame = requestAnimationFrame(updateGradient);
			}
		};

		// Mouse leave handler - return to center
		const handleMouseLeave = () => {
			targetX = 0;
			targetY = 0;

			if (!animationFrame) {
				animationFrame = requestAnimationFrame(updateGradient);
			}
		};

		// Add event listeners
		box.addEventListener('mousemove', handleMouseMove);
		box.addEventListener('mouseleave', handleMouseLeave);
	});
});
